import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { ProductFeatures } from "./type";

const AdminProductFeaturesDetail = forwardRef<any, { data: ProductFeatures }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);

    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"Code"}
                label={{
                    text: localize.getString("code"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Name"}
                label={{
                    text: localize.getString("name"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Icon"}
                label={{
                    text: localize.getString("icon"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"ProductCategoryName"}
                label={{
                    text: localize.getString("productCategoryName"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"ProductFeatureValueTypeName"}
                label={{
                    text: localize.getString("ProductFeatureValueTypeName"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default AdminProductFeaturesDetail;